module.exports = __webpack_public_path__ + "static/img/vrroad_combination01.abe84243.png";